import { Box, CircularProgress } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { LOADING } from './constants';

/**
 * Shows loading indicator
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const Loading = () => {
  const {
    getTestId
  } = useTestId();
  return /*#__PURE__*/_jsx(Box, {
    "data-testid": getTestId(LOADING),
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
    minHeight: "60px",
    children: /*#__PURE__*/_jsx(CircularProgress, {
      color: "primary"
    })
  });
};
//# sourceMappingURL=Loading.js.map